import Site from 'es/app/business-logic/domain-models/Site';
import HttpClient from 'es/core/net/http';
import qs from 'query-string';

export async function flushCache(site?: Site): Promise<number> {
    const query = {
        companyAlias: site?.companyAlias || undefined,
        facilityAlias: site?.facilityAlias || undefined,
    };

    const url = qs.stringifyUrl({ url: 'diagnostics/flush-cache', query });

    try {
        const response = await HttpClient.useInternalApi.asAuthorised().post(url, {});
        if (!response.isSuccess) return -1;

        return response.data as number;
    } catch (error) {
        return -1;
    }
}

export default flushCache;
